var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_1404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.0752,
    y: 1,
    width: 9.81445,
    height: 18,
    rx: 4,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.07666C1.34315 8.07666 0 9.41981 0 11.0767V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V11.0767C20 9.41981 18.6569 8.07666 17 8.07666H3ZM12.3938 12.8016C12.3938 13.7335 11.8613 14.541 11.084 14.9364V16.8071C11.084 17.3594 10.6363 17.8071 10.084 17.8071H9.97852C9.42623 17.8071 8.97852 17.3594 8.97852 16.8071V14.967C8.16752 14.5837 7.60645 13.7582 7.60645 12.8016C7.60645 11.4796 8.67813 10.408 10.0001 10.408C11.3221 10.408 12.3938 11.4796 12.3938 12.8016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a1bb75e6463c7fd39f1e1b0c150ba9f5.svg";
export { ForwardRef as ReactComponent };